import React from 'react';
import { Link } from 'react-router-dom';

export default function DashboardButton({ active = false, to = '/dashboard' }) {
  return (
    <Link to={to} className={`tab-btn${active ? ' active' : ''}`}>
      Dashboard
    </Link>
  );
}
